import React from "react";
import ReconciliationBankNotesContext from "./ReconciliationBankNotesContext";
import { useState } from "react";
import { formatDate } from "../../../helpers/FormatHelper";
import { useEffect } from "react";
import AlertBox from "../../shared/AlertBox";
import { getBankNotesReconciliation, searchVaultReconciliation } from "../../../networking/NetworkingBankNotes";
import moment from "moment";
import { getRolesByUsername } from "../../../networking/NetworkingRoles";
import LoadingBox from "../../shared/LoadingBox";
import { DefaultReconciliation, getBNVaultBalances } from "../../../networking/NetworkingOrders";
import { GlobalSystemParametersNames } from "../../../../src/constants/GlobalSystemParametersNames";
import dayjs from "dayjs";
import { getCurrencyDenominationsToReconcile } from "../../../networking/NetworkingCurrencies";

const BANKNOTES_ADMIN = 'BankNotesAdmin'
const ReconciliationBankNotesProvider = ({ children }) => {

  const [data, setData] = useState([]);
  const [columnDetails, setColumnDetails] = useState(null);  
  let str_bnSystemDate=localStorage.getItem(GlobalSystemParametersNames.BNSystemDate);
  let bnSystemDate = dayjs(str_bnSystemDate, "YYYY-MM-DD").toDate(); ;
  const [dateReported, setDateReported] = useState(bnSystemDate);
  const [vaultSelected, setVaultSelected] = useState({});
  const [page, setPage] = useState('');
  const [vaultReconciliationRecord, setVaultReconciliationRecord] = useState({});
  const [currencies, setCurrencies] = useState([]);
  const [currencyDenominations, setCurrencyDenominations] = useState([]);
  const [currencyDenominationsFresh, setCurrencyDenominationsFresh] = useState([]);
  const [alertMessage, setAlertMessage] = useState({ show: false, title: '', message: '' })  
  const [confirmationMessage, setConfirmationMessage] = useState({ show: false, title: '', message: '', callback: null, callbackParams: [] })    
  const [isBankNotesAdmin, setIsBankNotesAdmin] = useState(false)  
  const [loading, setLoading] = useState(false)
  const [showDifferences, setShowDifferences] = useState(false)
  const [defaultReconciliation, setDefaultReconciliation] = useState([]) 
  const [vaultIdSearched, setVaultIdSearched] = useState(0)
  const [vaultBalances, setVaultBalances] = useState([])

  useEffect(() => {    
    const loadCurrencyDenominations = async () => {
      const vaultId = vaultReconciliationRecord.VaultReconciliationID > 0 ? vaultReconciliationRecord.VaultID : vaultSelected.id
      const currenciesResponse = await getCurrencyDenominationsToReconcile(vaultId || 0)      
      if (currenciesResponse && currenciesResponse.currencies) {
        setCurrencyDenominations(currenciesResponse.currencies);
        setCurrencyDenominationsFresh(JSON.parse(JSON.stringify(currenciesResponse.currencies)));
        const currencies = Array.from(
          new Map(
            currenciesResponse.currencies
              .filter(c => Array.isArray(c.Denominations))
              .map(c => [c.CurrencyID, { value: c.CurrencyID, name: c.CurrencyIDName }])
          ).values()
        );
        setCurrencies(currencies);        
      } else {
        setCurrencyDenominations([]);
        setCurrencyDenominationsFresh([]);
        setCurrencies([]);
      }
    };    
    const loadRoles = async () => {
      getRolesByUsername('ForeignExchange', localStorage.getItem('UserName')).then(
        (response) => {          
          if (response && Array.isArray(response) && response.map(e => e.toLowerCase()).includes(BANKNOTES_ADMIN.toLowerCase())) {
            setIsBankNotesAdmin(true)
          }
          else {
            setIsBankNotesAdmin(false)
          }
        }
      )
    }
    loadCurrencyDenominations();
    loadRoles();    
  }, []);

  useEffect(() => {
    const loadDefaultReconciliation = async () => {
      
      const vaultId = vaultReconciliationRecord.VaultReconciliationID > 0 ? vaultReconciliationRecord.VaultID : vaultSelected.id

      if (currencies === undefined || currencies === null || !Array.isArray(currencies) || vaultId !== vaultIdSearched) {        
        const currenciesResponse = await getCurrencyDenominationsToReconcile(vaultId || 0)        
        if (currenciesResponse && currenciesResponse.currencies) {
          setCurrencyDenominations(currenciesResponse.currencies);
          setCurrencyDenominationsFresh(JSON.parse(JSON.stringify(currenciesResponse.currencies)));
          const currencies = Array.from(
            new Map(
              currenciesResponse.currencies
                .filter(c => Array.isArray(c.Denominations))
                .map(c => [c.CurrencyID, { value: c.CurrencyID, name: c.CurrencyIDName }])
            ).values()
          );
          setCurrencies(currencies);
        } else {
          setCurrencyDenominations([]);
          setCurrencyDenominationsFresh([]);
          setCurrencies([]);
        }
        setVaultIdSearched(vaultId)
      }
      
      const reconciliationQuery = {
        currencies: currencies,
        vaultId: vaultId
      }
      const response = await DefaultReconciliation(reconciliationQuery);
      if (response && response.result) {
        setDefaultReconciliation(response.result || [])
      }
      
    }
    loadDefaultReconciliation();
  }, [vaultReconciliationRecord, currencies, vaultSelected]);

  useEffect(() => {
    const laadVaultBalances = async () => {
      setLoading(true)
      const balancesResponse = await getBNVaultBalances({ vaultId: vaultSelected.id });
      setLoading(false)

      let balances = []
      if (balancesResponse && Array.isArray(balancesResponse.result) && balancesResponse.result.length > 0) {
        let balances = balancesResponse.result
        balances = balancesResponse.result.filter(b => (Array.isArray(currencyDenominations) && currencyDenominations.some(c => c.CurrencyID === b.Currency)));        
        setVaultBalances(balances) // set balances in context for use in form and to avoid calling API again when needed                        
      } else {
        setVaultBalances([]) // set empty to avoid issues in form if API call fails or returns no data
      }
    };

    if (vaultSelected && Number(vaultSelected.id) > 0) {
      laadVaultBalances()
    }
    else {
      setVaultBalances([])
    }

  }, [vaultSelected])

  const loadVaultReconciliations = async () => {
    const response = await searchVaultReconciliation(0, '', null, dateReported);
    if (Array.isArray(response.result)) {
      setData(response.result);
    } else {
      setData([]);
    }
    if (response && response.columnDetail != null) {
      const _columnDetail = JSON.parse(response.columnDetail);
      setColumnDetails(_columnDetail);
    }    
  };

  useEffect(() => {
    loadVaultReconciliations();
  }, [dateReported])

  const loadVaultReconciliation = async (reconciliationId) => {

    if (!reconciliationId || reconciliationId === 0) {
      clearReconciliationInfo();
      return
    }

    const reconciliationInfo = await getBankNotesReconciliation(reconciliationId)
    if (reconciliationInfo && reconciliationInfo.VaultReconciliationID > 0) {

      setLoading(true)
      const balancesResponse = await getBNVaultBalances({ vaultId: reconciliationInfo.VaultID });
      setLoading(false)

      let vaultBalances = []
      if (balancesResponse && Array.isArray(balancesResponse.result) && balancesResponse.result.length > 0) {
        vaultBalances = balancesResponse.result
        vaultBalances = balancesResponse.result.filter(b => (Array.isArray(currencyDenominations) && currencyDenominations.some(c => c.CurrencyID === b.Currency)));        
        setVaultBalances(vaultBalances) // set balances in context for use in form and to avoid calling API again when needed                        
      } else {
        setVaultBalances([]) // set empty to avoid issues in form if API call fails or returns no data
      }

      if(reconciliationInfo.ReconciliationItems){
        reconciliationInfo.ReconciliationItems.forEach(item => {

          // helper to find matching balance entry
          const findBalance = (currencyId, denomDesc) => {
            if (!Array.isArray(vaultBalances)) return null;
            return vaultBalances.find(b => b.Currency === currencyId && b['Denomination Description'] === denomDesc) || null;
          }

          item.ReconciliationDenominations.forEach(den => {
            const balanceForItemCurrency = findBalance(item.CurrencyID, den.DenominationDescription);
            den.InventoryNoNotes = balanceForItemCurrency ? balanceForItemCurrency['In Stock'] : 0          
            den.InventoryValue = den.InventoryNoNotes
            den.VbUpdateToken = balanceForItemCurrency ? balanceForItemCurrency['VbUpdateToken'] : ''
          })
          // kept: list of balances for this currency if needed elsewhere
          const balanceForItemCurrency = vaultBalances.filter(b => b.Currency === item.CurrencyID)

        })
      }

      setVaultReconciliationRecord(reconciliationInfo)
      setVaultSelected({ id: reconciliationInfo.VaultID, name: reconciliationInfo.VaultName })
      setShowDifferences(isBankNotesAdmin)
    }
    else {
      clearReconciliationInfo();
    }
  }

  const alreadyReconciliated = () => {
    const record = data.find(r => moment(r.DateReported).isSame(moment(dateReported), 'day') && r.VaultID === Number(vaultSelected.id))
    if (record && record.VaultReconciliationID > 0)
      return record.VaultReconciliationID
    else {
       setShowDifferences(isBankNotesAdmin)
      return 0
    }
  }

  const clearReconciliationInfo = () => {    
    setVaultReconciliationRecord({});
    const currenciesReloaded = currencies.map(c => {
      return {
        value: c.value,
        name: c.name
      };
    });
    setCurrencies(currenciesReloaded);
    setCurrencyDenominations(currencyDenominationsFresh);
    setVaultSelected({});
    setVaultBalances([]);
    setShowDifferences(false)
    reload()
  }

  const closeAlertMessage = () => {
    setAlertMessage({ ...alertMessage, show: false, title: '', message: '' })
  }

  const onYesToConfirmationMessage = () => {    
    if (confirmationMessage.callback !== null) {
      confirmationMessage.callback(...confirmationMessage.callbackParams)
      setConfirmationMessage({ ...confirmationMessage, show: false, title: '', message: '', callbac: null })
    }
  }

  const reload = () => {
    loadVaultReconciliations();    
  }

  return (
    <ReconciliationBankNotesContext.Provider
      value={{
        data,
        columnDetails,
        dateReported,
        setDateReported,
        vaultSelected,
        setVaultSelected,
        page,
        setPage,
        vaultReconciliationRecord,
        setVaultReconciliationRecord,
        loadVaultReconciliation,
        currencies,
        setCurrencies,
        currencyDenominations,
        setCurrencyDenominations,
        alertMessage,
        setAlertMessage,
        alreadyReconciliated,
        confirmationMessage,
        setConfirmationMessage,
        onYesToConfirmationMessage,
        reload,
        isBankNotesAdmin,        
        setLoading,
        showDifferences,
        defaultReconciliation,
        vaultBalances,
        setVaultBalances
      }}
    >
      <LoadingBox loading={loading} />
      {children}
      <AlertBox id="rc-alert-1" type="Ok" open={alertMessage.show} title={alertMessage.title} message={alertMessage.message}
        okClick={closeAlertMessage} onClose={closeAlertMessage} />
      <AlertBox id="rc-confirmMessage" open={confirmationMessage.show} title={confirmationMessage.title} message={confirmationMessage.message} type="Yes/No"
        yesClick={() => onYesToConfirmationMessage()}
        onClose={() => setConfirmationMessage({ ...confirmationMessage, show: false, title: '', message: '', callback: null, callbackParams: [] })}
        noClick={() => setConfirmationMessage({ ...confirmationMessage, show: false, title: '', message: '', callback: null, callbackParams: [] })}
      />        
    </ReconciliationBankNotesContext.Provider>
  );
};

export default ReconciliationBankNotesProvider;